export const permissionsSelector = state => state.permissions;
